export type LabOptionColor = string | string[];

const commaSeparatedHexPalette = /^#[0-9a-f]{6}(?:\s*,\s*#[0-9a-f]{6})+$/i;

export const getLabOptionColors = (
  color: LabOptionColor | null | undefined,
): string[] => {
  const colors = Array.isArray(color)
    ? color
    : color
      ? commaSeparatedHexPalette.test(color.trim())
        ? color.split(',')
        : [color]
      : [];

  return colors
    .map(value => value.trim())
    .filter(value => value.length > 0);
};

export const getPrimaryLabOptionColor = (
  color: LabOptionColor | null | undefined,
): string | undefined => getLabOptionColors(color)[0];

export const getLabOptionColorBackground = (
  color: LabOptionColor | null | undefined,
): string | undefined => {
  const colors = getLabOptionColors(color);

  if (colors.length < 2) return colors[0];

  const segmentSize = 100 / colors.length;
  const stops = colors.flatMap((value, index) => [
    `${value} ${segmentSize * index}%`,
    `${value} ${segmentSize * (index + 1)}%`,
  ]);

  return `linear-gradient(135deg, ${stops.join(', ')})`;
};
